export default __webpack_public_path__ + "static/Greycliffcf-light-webfont-de75c0414ad70557f46f2d6422bf97ef.woff2";